import React from "react";
import { useScrollReveal, useCountUp } from "./useAnimations";
import "./CaseStudies.scss";

const studies = [
  {
    sector: "Public Sector \u2014 Health",
    client: "NHS",
    type: "Technology Consulting",
    description:
      "How a major NHS trust reduced technology risk and strengthened architecture decisions under governance-grade oversight.",
    stat: 60,
    statSuffix: "%",
    statLabel: "Risk reduction in 6 weeks",
    color: "#005EB8",
    link:
      "/client-story/collaborative-platform-on-web-for-a-wing-of-nhs-to-deliver-information/",
    image:
      "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?auto=format&fit=crop&w=600&q=80",
    imageAlt: "Hospital corridor with modern technology",
  },
  {
    sector: "Research \u2014 Science",
    client: "CERN",
    type: "Platform Engineering",
    description:
      "How CERN\u2019s data infrastructure was reviewed and modernised to meet the demands of global research at scale.",
    stat: 240,
    statSuffix: "K",
    statLabel: "Annual savings identified",
    color: "#3838A8",
    link:
      "/client-story/digiryte-developed-a-custom-cloud-based-solution-for-mro-pro/",
    image:
      "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=600&q=80",
    imageAlt: "Server room with data infrastructure",
  },
  {
    sector: "Media \u2014 Broadcasting",
    client: "Channel 4",
    type: "IT Audit & Delivery",
    description:
      "How Channel 4\u2019s engineering teams improved delivery performance through structured audit and governance oversight.",
    stat: 95,
    statSuffix: "%",
    statLabel: "Compliance ready from day one",
    color: "#E4002B",
    link:
      "/client-story/we-delivered-ai-vs-human-dating-software-for-channel-4-in-6-weeks/",
    image:
      "https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&w=600&q=80",
    imageAlt: "Broadcast media technology team",
  },
];

const CaseCard = ({ cs, index }) => {
  const [ref, vis] = useScrollReveal({ threshold: 0.1 });
  const count = useCountUp(cs.stat, 2000, vis);

  return (
    <a
      ref={ref}
      href={cs.link}
      className={`cstudy__card${vis ? " is-visible" : ""}`}
      style={{ transitionDelay: `${index * 0.12}s` }}
    >
      <div className="cstudy__card-img">
        <img src={cs.image} alt={cs.imageAlt} loading="lazy" />
      </div>
      <div className="cstudy__card-body">
        <span className="cstudy__card-sector">{cs.sector}</span>
        <h3 className="cstudy__card-client" style={{ color: cs.color }}>
          {cs.client}
        </h3>
        <span className="cstudy__card-type">{cs.type}</span>
        <p className="cstudy__card-quote">{cs.description}</p>
      </div>
      <div className="cstudy__card-stat" style={{ borderColor: cs.color }}>
        <span className="cstudy__card-stat-num" style={{ color: cs.color }}>
          {cs.statSuffix === "K" ? "\u00A3" : ""}
          {count}
          <span className="cstudy__card-stat-suffix">{cs.statSuffix}</span>
        </span>
        <span className="cstudy__card-stat-label">{cs.statLabel}</span>
      </div>
    </a>
  );
};

const CaseStudies = () => {
  const [hRef, hVis] = useScrollReveal();

  return (
    <section className="cstudy">
      <div className="cstudy__inner">
        <div ref={hRef} className="cstudy__header">
          <span className={`cstudy__label${hVis ? " is-visible" : ""}`}>
            Case Studies
          </span>
          <h2 className={`cstudy__title${hVis ? " is-visible" : ""}`}>
            Outcomes Delivered in Complex, <em>Regulated Environments</em>
          </h2>
          <p className={`cstudy__subtitle${hVis ? " is-visible" : ""}`}>
            Work delivered across public sector, scientific research and
            broadcast media - where governance is non-negotiable.
          </p>
        </div>

        <div className="cstudy__grid">
          {studies.map((cs, i) => (
            <CaseCard key={i} cs={cs} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;
